import { Renderer } from './Renderer';
import { Map, View } from 'ol';
import {Tile as ollayerTile} from 'ol/layer'
import { Coordinate } from 'ol/coordinate';
import Style from 'ol/style/Style';

export class StartRenderer extends Renderer<any> {
    // dummy class so it doesn't have to be nullable
    text = ''
    value = ''
    map = new Map({controls: []})
    projection = ''
    layer  = new ollayerTile()

    GetType(): string { 
        return ''
    }
    CreateView(centre: Coordinate): View {
        return new View({})
    }
}